module.exports = __webpack_public_path__ + "static/media/for-investors-first.121ae766.jpg";